import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { useLocation } from "react-router-dom";
import { getSchemeBankAccountList } from '../../../helper/Api';
import { BiSolidEdit } from 'react-icons/bi';
import { AiOutlineEye } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const SchemeAccountList = (filterDate) => {
    const { authData } = useSelector((state) => state.authData);
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [data, setData] = useState([]);
    const customStyles = {
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "14px"
            },
        },
    };

    const columns = [
        {
            name: 'Department Name',
            selector: (row) => row.department_name,
            sortable: true,
            width: "180px"
        },
        {
            name: 'Department Code',
            selector: (row) => row.department_code,
            sortable: true,
            width: "180px",
            right: false
        },
        {
            name: 'Department Level',
            selector: (row) => row.department_level,
            sortable: true,
            width: "180px",
            right: false
        },
        {
            name: 'Scheme Name',
            selector: (row) => row.scheme_name,
            sortable: true,
            wrap: true,
            width: "300px",
            right: false
        },
        {
            name: 'Scheme No',
            selector: (row) => row.scheme_code,
            sortable: true,
            width: "180px",
            right: false
        },
        {
            name: 'Account Name',
            selector: (row) => row.account_name,
            sortable: true,
            wrap: true,
            width: "180px",
            right: false
        },
        {
            name: 'Account No',
            selector: (row) => row.account_no,
            sortable: true,
            width: "180px",
            right: false
        },
    ];

    const handleChangeRowsPerPage = (currentRowsPerPage, currentPage) => {
        setRowsPerPage(currentRowsPerPage);
        setCurrentPage(1);
    };

    const fetchList = async () => {
        try {
            const resp = await getSchemeBankAccountList({
                searchStr: filterDate.searchStr || "",
                tier: filterDate.tier || ""
            });
            if (resp.data.status) {
                setData(resp.data.result);
            }
        } catch (error) {
            setData([]);
        }
    }
    useEffect(() => {
        fetchList();
    }, [filterDate.searchStr, filterDate.tier])



    return (
        <div>
            <DataTable
                customStyles={customStyles}
                className="dataTables_wrapper"
                columns={columns}
                data={data}
                fixedHeader
                fixedHeaderScrollHeight="600px"
                pagination
                paginationPerPage={rowsPerPage}
                paginationTotalRows={data.length}
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                onChangeRowsPerPage={handleChangeRowsPerPage}
            />
        </div>
    )
}

export default SchemeAccountList
